var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 146,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Clock_svg__clip0_510_10952)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Clock_svg__clip1_510_10952)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EF3E51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 27c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zM11.5 73c0-31.756 25.744-57.5 57.5-57.5s57.5 25.744 57.5 57.5-25.744 57.5-57.5 57.5S11.5 104.756 11.5 73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 38.5a5.75 5.75 0 015.75 5.75v25.196l19.822 9.911a5.75 5.75 0 01-5.144 10.286l-23-11.5A5.75 5.75 0 0163.25 73V44.25A5.75 5.75 0 0169 38.5z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Clock_svg__clip2_510_10952)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.333,
    y: 83.334,
    width: 43.333,
    height: 43.333,
    rx: 21.667,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 83.334c11.966 0 21.667 9.7 21.667 21.666 0 11.966-9.7 21.667-21.667 21.667-11.966 0-21.667-9.701-21.667-21.667 0-11.966 9.7-21.666 21.667-21.666zm0 18.958A2.708 2.708 0 0030.292 105v10.833a2.709 2.709 0 105.416 0V105A2.708 2.708 0 0033 102.292zm-3.25-7.042a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0z",
    fill: "#EF3E51"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Clock_svg__clip0_510_10952"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.055 .865)",
    d: "M0 0h137.89v144.27H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Clock_svg__clip1_510_10952"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11.5 15.5)",
    d: "M0 0h115v115H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Clock_svg__clip2_510_10952"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.333,
    y: 83.334,
    width: 43.333,
    height: 43.333,
    rx: 21.667,
    fill: "#fff"
  })))));
}

export default SvgClock;